import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '8px',
    boxSizing: 'border-box',
    width: '250px',
    height: '250px',
    padding: '4px',
    background: theme.palette.secondary.main
  }
}))

export default useStyles
